/**
 * Every auth failure kind → the locale key that explains it. (Citizen first
 * run · D10)
 *
 * A TYPED MAP OF FULL LITERAL KEYS, so every key is one `check-key-usage.mjs`
 * can see, and `dynamic-key-coverage.spec.ts` asserts the map covers exactly
 * `AUTH_ERROR_KINDS` from `@tonnie/foundation` and that every key exists in
 * en.json (the other locales follow by the `i18n:check` parity gate). Read
 * through `useAuthErrorMessage`, never at a call site.
 */
import type { AuthErrorKind } from '@tonnie/foundation';

export const AUTH_ERROR_KEY = {
  email_taken: 'auth.providerErrors.emailTaken',
  account_not_found: 'auth.providerErrors.accountNotFound',
  password_incorrect: 'auth.providerErrors.passwordIncorrect',
  credentials_incorrect: 'auth.providerErrors.credentialsIncorrect',
  password_breached: 'auth.providerErrors.passwordBreached',
  password_too_short: 'auth.providerErrors.passwordTooShort',
  password_too_weak: 'auth.providerErrors.passwordTooWeak',
  password_too_long: 'auth.providerErrors.passwordTooLong',
  password_unchanged: 'auth.providerErrors.passwordUnchanged',
  code_incorrect: 'auth.providerErrors.codeIncorrect',
  code_expired: 'auth.providerErrors.codeExpired',
  code_attempts_exhausted: 'auth.providerErrors.codeAttemptsExhausted',
  email_invalid: 'auth.providerErrors.emailInvalid',
  email_not_allowed: 'auth.providerErrors.emailNotAllowed',
  too_many_attempts: 'auth.providerErrors.tooManyAttempts',
  account_locked: 'auth.providerErrors.accountLocked',
  already_signed_in: 'auth.providerErrors.alreadySignedIn',
  bot_check_failed: 'auth.providerErrors.botCheckFailed',
  password_not_set: 'auth.providerErrors.passwordNotSet',
  reverification_required: 'auth.providerErrors.reverificationRequired',
  account_unavailable: 'auth.providerErrors.accountUnavailable',
  network_unreachable: 'auth.providerErrors.networkUnreachable',
  social_cancelled: 'auth.providerErrors.socialCancelled',
  social_account_in_use: 'auth.providerErrors.socialAccountInUse',
} as const satisfies Record<AuthErrorKind, string>;
